import AddTecdocCategories from '@/pages/tecdoc/addTecdocCategory'
import React from 'react'

const ManagementCatalogGenericArticles = () => {
    return (
        <div>
            <AddTecdocCategories />
        </div>
    )
}

export default ManagementCatalogGenericArticles